// Get the API base URL - now using relative URLs for Docker proxy
export const getApiBaseUrl = () => {
  return '/api'; // Use relative URL for nginx proxy
};

// Construct a full API URL by combining the base URL with the endpoint path
export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  
  // Ensure endpoint starts with '/'
  const apiEndpoint = endpoint.startsWith('/') ? endpoint : '/' + endpoint;
  
  return `${baseUrl}${apiEndpoint}`;
};

/**
 * Parse a DRF error response into a single human-readable string.
 * Handles: string messages, { detail }, { non_field_errors }, and field-level errors.
 */
export const parseDRFError = (err) => {
  const data = err.response?.data;
  if (!data) return err.message || 'An unexpected error occurred.';
  if (typeof data === 'string') return data;
  if (data.detail) return data.detail;
  // Flatten all field/non_field messages into one string
  const messages = Object.entries(data).flatMap(([, val]) =>
    Array.isArray(val) ? val : [String(val)]
  );
  return messages.join(' ') || err.message || 'An unexpected error occurred.';
};